import React from "react";
import { Body1Stronger, Checkbox, CheckboxOnChangeData, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { TimeSheetEntry } from "../../../store/Data";
import { useEditorStyles } from "../../Styles/Editor";
import { useConsultants } from "../../Tools/ObjectLoader";

const useStyles = makeStyles({
    row:
    {
        display: "grid",
        gridTemplateAreas: `
                            "header header header header checkbox"
                            "content count unitprice price checkbox"
                            `,
        gridTemplateColumns: "9fr 3fr 4fr 4fr 1fr",
        gridTemplateRows: "auto auto",
        alignItems: "center",
        ...shorthands.gap("0.5rem"),
    },
});

export interface InvoiceLine_ts_Props {
    line: TimeSheetEntry;
    onSelectionChange: (id: string, selected: boolean) => void;
    allowEdition: boolean;
    isSelected: boolean;
    isNeomytic: boolean;
    isCreditNote: boolean;
}
export const InvoiceLine_ts = ({ line, onSelectionChange, allowEdition, isSelected, isNeomytic, isCreditNote }: InvoiceLine_ts_Props) => {
    const projects = useSelector((state: ApplicationState) => state.data.projects);
    const projectsAssigments = useSelector((state: ApplicationState) => state.data.projectsAssigments);
    const { consultants } = useConsultants();
    const projectAssigment = React.useMemo(() => {
        return projectsAssigments ? projectsAssigments.find((c) => line.projectAssignmentid && c.projectAssignmentid === line.projectAssignmentid) : undefined;
    }, [projectsAssigments, line]);
    const project = React.useMemo(() => {
        return projects ? projects.find((c) => projectAssigment && c.projectid === projectAssigment.projectid) : undefined;
    }, [projects, projectAssigment]);
    const consultant = React.useMemo(() => {
        return consultants ? consultants.find((c) => projectAssigment && c.consultantid === projectAssigment.consultantid) : undefined;
    }, [consultants, projectAssigment]);
    const total = React.useMemo(() => {
        if (isCreditNote) {
            if (isNeomytic) {
                return projectAssigment ? projectAssigment.customerPrice * (-line.count) : 0;
            }
            return projectAssigment ? projectAssigment.consultantPrice * (-line.count) : 0;
        }
        if (isNeomytic) {
            return projectAssigment ? projectAssigment.customerPrice * line.count : 0;
        }
        return projectAssigment ? projectAssigment.consultantPrice * line.count : 0;
    }, [line, projectAssigment]);

    const count = React.useMemo(() => {
        if (isCreditNote) {
            return -line.count;
        } 
        return line.count;
    }, [line]);


    const styles = useEditorStyles();
    const styles22 = useStyles();

    return (<div className={styles.ContentBoxBrandBackground2} style={{
        flexGrow: "1"
    }}>
        <div className={styles22.row}>
            <div style={{ gridArea: "header", display: "flex", flexDirection: "row", gap: tokens.spacingHorizontalSNudge }}>
                <Body1Stronger>{projectAssigment?.displayName + " (" + project?.displayName + ")"}</Body1Stronger>
                {isNeomytic &&
                    <Body1Stronger>{consultant?.displayName}</Body1Stronger>
                }
                <Body1Stronger>{"(" + (line.date ? new Date(line.date).toLocaleDateString() : "-") + ")"}</Body1Stronger>
            </div>
            <div style={{ gridArea: "count" }}>
                <><Body1Stronger>{count.toString()}</Body1Stronger></>
            </div>
            <div style={{ gridArea: "unitprice", display: "flex" }}>
                {isNeomytic
                    ?
                    <><Body1Stronger>{projectAssigment?.customerPrice.toLocaleString(undefined, { style: 'currency', currency: 'EUR', maximumFractionDigits: 3 }) + "/" + projectAssigment?.unitOfTime}</Body1Stronger></>
                    :
                    <><Body1Stronger>{projectAssigment?.consultantPrice.toLocaleString(undefined, { style: 'currency', currency: 'EUR', maximumFractionDigits: 3 }) + "/" + projectAssigment?.unitOfTime}</Body1Stronger></>
                }
            </div>
            <div style={{ gridArea: "price", display: "flex" }}>
                <><Body1Stronger>{total.toLocaleString(undefined, { style: 'currency', currency: 'EUR', maximumFractionDigits: 3 })}</Body1Stronger></>
            </div>
            <Checkbox
                style={{ gridArea: "checkbox" }}
                size="large"
                disabled={!allowEdition}
                checked={isSelected}
                onChange={(e: React.ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
                    if (onSelectionChange && line.timesheetEntryid) onSelectionChange(line.timesheetEntryid, data.checked === "mixed" ? true : data.checked);
                }}
                indicator={{
                    style: !allowEdition ? {
                        color: tokens.colorNeutralForeground1,
                        WebkitTextFillColor: tokens.colorNeutralForeground1, // required for Chrome }
                    } : {}
                }}
            />
        </div>
    </div>);
};
